"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var palette = _interopRequireWildcard(require("../shared/oldDocumentSignerUI/palette"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// MaterialUI Components
// Constants
var styles = function styles(theme) {
  return {
    snackbar: {
      background: 'white',
      display: 'grid',
      gridTemplateColumns: 'repeat(8, 1fr)'
    },
    snackbarContent: {
      gridColumn: '2 / -1'
    },
    snackbarMessage: {
      gridColumn: '1 / 7',
      display: 'grid',
      gridTemplateColumns: 'repeat(10, 1fr)',
      color: 'black'
    },
    snackbarAction: {
      gridColumn: '7 / span 2',
      padding: 10,
      margin: 'auto'
    },
    successNotification: {
      gridColumn: '1 / 2',
      color: palette.success2,
      alignSelf: 'center'
    },
    error: {
      gridColumn: '1 / 2',
      alignSelf: 'center',
      color: theme.palette.error.main
    }
  };
};

var getMessage = function getMessage(type) {
  switch (type) {
    case 'documentComplete':
      return "Success! You've completed all the required fields for this form. Click continue to move to the next form!";

    case 'documentError':
      return 'There are errors in a form. Expand the form in the sidebar for details.';

    default:
      return 'An unknown error occurred while performing your action. Please try again shortly.';
  }
};

var GrowlNotification = function GrowlNotification(props) {
  var isOpen = props.isOpen,
      classes = props.classes,
      onClose = props.onClose,
      onExited = props.onExited,
      onContinue = props.onContinue,
      type = props.type;
  var message = getMessage(type);
  var icon = type === 'documentComplete' ? /*#__PURE__*/_react.default.createElement(_icons.CheckCircle, {
    className: classes.successNotification
  }) : /*#__PURE__*/_react.default.createElement(_icons.Error, {
    className: classes.error
  });
  return /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    ContentProps: {
      classes: {
        root: classes.snackbar,
        message: classes.snackbarMessage,
        action: classes.snackbarAction
      }
    },
    open: isOpen,
    onClose: onClose,
    onExited: onExited,
    autoHideDuration: 7000,
    message: [icon, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.snackbarContent
    }, message)],
    action: type === 'documentComplete' && /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: onContinue,
      color: "primary",
      variant: "contained"
    }, "Continue"),
    "data-test-id": "GrowlNotification-root"
  });
};

var _default = (0, _styles.withStyles)(styles)(GrowlNotification);

exports.default = _default;